module.exports = __webpack_public_path__ + "static/media/hiw3.34eff84a.svg";